/* eslint-disable max-classes-per-file */
import Base, { ErrorBase } from 'requests/objects/_base'

/**
 * Order Object
 */
export default class OrderQuoteService extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.orderQuoteServiceId orderQuoteServiceId
     * @param {string=} data.name name
     */
    constructor({
        orderQuoteServiceId = 0,
        name = '',
        ...data
    } = {}) {
        super(data)
        this.orderQuoteServiceId = orderQuoteServiceId
        this.name = name
    }
}

/**
 * User Object used to bind error message
 */
export class ErrorOrderQuoteService extends ErrorBase {
    constructor() {
        super()
        this.orderQuoteServiceId = ''
        this.name = ''
    }
}
